<div class="d-flex flex-column">
  <h1 class="mb-4">Salud</h1>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <a mat-raised-button color="primary" (click)="addNewHealthItem()"
      >NUEVO POST</a
    >
    <div class="d-flex align-items-center">
      <span class="mr-3 ">Estado: </span>
      <mat-form-field>
        <mat-select
          [(value)]="selectedState"
          (selectionChange)="loadHealthArticlesListByStatus()"
        >
          <mat-option *ngFor="let state of states" [value]="state.value">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <table mat-table [dataSource]="healthList">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Titulo</th>
      <td mat-cell *matCellDef="let el">
        {{ el.title }}
      </td>
    </ng-container>
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef>Tags</th>
      <td mat-cell *matCellDef="let el">{{ getTagDetails(el.tags) }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let el">{{ getTagStatus(el.status) }}</td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let el">{{ getHealthArticleDate(el.date) }}</td>
    </ng-container>
    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef></th>
      <td width="5%" mat-cell *matCellDef="let el">
        <button
          mat-button
          mat-icon-button
          [matMenuTriggerFor]="healthTableOptions"
        >
          <i class="material-icons">more_vert</i>
        </button>
        <mat-menu #healthTableOptions="matMenu" xPosition="before">
          <button mat-menu-item (click)="editHealthItem(el)">Editar</button>
        </mat-menu>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="goToHealthDetail(row.id)"
      class="link-table"
    ></tr>
  </table>

  <mat-paginator
    [length]="totalRecords"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
